import { render, staticRenderFns } from "./BlockType29.vue?vue&type=template&id=0b524caa&scoped=true&"
import script from "./BlockType29.vue?vue&type=script&lang=ts&"
export * from "./BlockType29.vue?vue&type=script&lang=ts&"
import style0 from "./BlockType29.vue?vue&type=style&index=0&id=0b524caa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b524caa",
  null
  
)

export default component.exports